export const resolveAfter = async (time, result = null) => new Promise(
  (resolve, reject) => setTimeout(() => resolve(result), time)
)

export const rejectAfter = async (time, error = new Error('pooop')) => new Promise(
  (resolve, reject) => setTimeout(() => reject(error), time)
)
